import FormCheckbox from "component/form/form_checked";
import { useActionTermAndPolicy } from "hook/term/useActionTerm";
import React from "react";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const RegisterCheck = () => {
  // -------------------------- VAR -----------------------------
  const { term, policy } = useActionTermAndPolicy();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <FormCheckbox
      name="agree"
      initialValue={true}
      label={
        <span>
          Tôi xác nhận đã đọc, hiểu và đồng ý với{" "}
          <a
            onClick={() => term.handleOpen()}
            className="text-blue-500 underline"
          >
            điều khoản sử dụng dịch vụ
          </a>{" "}
          và{" "}
          <a
            onClick={() => policy.handleOpen()}
            className="text-blue-500 underline"
          >
            chính sách bảo mật
          </a>
        </span>
      }
    />
  );
};
export default RegisterCheck;
